module.exports = __webpack_public_path__ + "static/media/HS_DP.e3ada517.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Introduction/Assets/HS_DP.png
// module id = 505
// module chunks = 1